// extracted by mini-css-extract-plugin
module.exports = {"modal":"Container-module__modal--Ui-Pd","title":"Container-module__title--Tdgb6"};